module.exports = __webpack_public_path__ + "static/media/08LoganBrothersHaywoodRdmuralfinishedmuralTHUMBNAIL.0b879039.webp";